import utils from '@/mixins/utils.js'

// Função para verificar pendências baseada nos alertas da TabelaCadastros.vue
function verificarPendencias(item) {
  // Se não tem tratamento concluído, mostra pendência
  if (item.ult_tratam_concluido == null) {
    return 'Conclusão de tratamento'
  }

  return ''
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
        item.idade
      } ${item.idade > 1 ? 'anos' : 'ano'})`
      return idade
    },
  },
  Mãe: 'no_mae',
  Concluído: {
    callback: (item) => {
      return item.ult_tratam_concluido != null
        ? utils.methods.formatDate(item.ult_tratam_concluido)
        : ''
    },
  },
  Microárea: {
    field: 'micro_area',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  CPF: {
    field: 'nu_cpf',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  CNS: {
    field: 'nu_cns',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'Cadastrado por': 'no_profissional',
  Atendimento: {
    callback: (item) => {
      return item.dados
    },
  },
  Numerador: {
    callback: (item) => {
      return item.num_trat_concluido > 0 ? 'Sim' : ''
    },
  },
}

export const infoHtml = ``
